/* tslint:disable */
/* eslint-disable */
/**
 * Amplified Intelligence - Media Plans API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../runtime';
/**
 *
 * @export
 * @interface ShareUserAccessDto
 */
export interface ShareUserAccessDto {
    /**
     *
     * @type {string}
     * @memberof ShareUserAccessDto
     */
    campaignId?: string;
    /**
     *
     * @type {string}
     * @memberof ShareUserAccessDto
     */
    scenarioId?: string | null;
    /**
     *
     * @type {string}
     * @memberof ShareUserAccessDto
     */
    userId?: string;
    /**
     *
     * @type {string}
     * @memberof ShareUserAccessDto
     */
    firstName?: string | null;
    /**
     *
     * @type {string}
     * @memberof ShareUserAccessDto
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the ShareUserAccessDto interface.
 */
export function instanceOfShareUserAccessDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShareUserAccessDtoFromJSON(json: any): ShareUserAccessDto {
    return ShareUserAccessDtoFromJSONTyped(json, false);
}

export function ShareUserAccessDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ShareUserAccessDto {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        campaignId: !exists(json, 'campaign_id') ? undefined : json['campaign_id'],
        scenarioId: !exists(json, 'scenario_id') ? undefined : json['scenario_id'],
        userId: !exists(json, 'user_id') ? undefined : json['user_id'],
        firstName: !exists(json, 'first_name') ? undefined : json['first_name'],
        lastName: !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function ShareUserAccessDtoToJSON(value?: ShareUserAccessDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        campaign_id: value.campaignId,
        scenario_id: value.scenarioId,
        user_id: value.userId,
        first_name: value.firstName,
        last_name: value.lastName,
    };
}
